"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Box = void 0;
var error_1 = require("./error");
var asn1js = __importStar(require("asn1js"));
var modena_1 = require("@axelity/modena");
var Box = /** @class */ (function () {
    function Box(_a) {
        var id = _a.id, wallet = _a.wallet, account = _a.account, context = _a.context, scope = _a.scope, url = _a.url, parent = _a.parent;
        this.id = id;
        this.wallet = wallet;
        this.account = account;
        this.context = context;
        this.scope = scope.toUpperCase();
        this.url = url;
        this.parent = parent || null;
        if (!this.scope || this.scope === '') {
            throw new error_1.ValidationError("A request for a box was generated. The request is rejected because a valid, non-empty scope shall be provided");
        }
        if (!this.id || this.id.length !== 27) {
            throw new error_1.ValidationError("A request for a box was generated. The request is rejected because a box identifier shall have 27 characters");
        }
        if (this.parent && this.parent !== null && this.parent.length !== 27) {
            throw new error_1.ValidationError("A request for a box was generated. The request is rejected because a parent identifier shall have 27 characters");
        }
        if (!this.wallet || this.wallet.length < 42 || this.wallet.length > 46) {
            throw new error_1.ValidationError("A request for a box was generated. The request is rejected because a wallet identifier shall be unique and have 42-46 characters");
        }
        Box.schema = new asn1js.Sequence({
            name: 'dataBox',
            value: [
                new asn1js.Integer({
                    name: 'version',
                }),
                new asn1js.Utf8String({
                    name: 'serial',
                }),
                new asn1js.OctetString({
                    name: 'nonce',
                }),
                new asn1js.OctetString({
                    name: 'boxedData',
                }),
            ],
        });
    }
    Box.box = function (_a) {
        var passWallet = _a.passWallet, data = _a.data;
        return __awaiter(this, void 0, void 0, function () {
            var path, address, nonce, boxedData, sequence;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        path = modena_1.Utilities.uniqueId();
                        return [4 /*yield*/, passWallet.deriveAddress({
                                path: path,
                                type: modena_1.AddressType.BOX,
                            })];
                    case 1:
                        address = _b.sent();
                        return [4 /*yield*/, modena_1.Address.nonce()];
                    case 2:
                        nonce = _b.sent();
                        return [4 /*yield*/, address.secretBoxEncrypt({
                                message: data,
                                nonce: nonce,
                            })];
                    case 3:
                        boxedData = _b.sent();
                        sequence = new asn1js.Sequence({
                            value: [
                                new asn1js.Integer({ value: 1 }),
                                new asn1js.Utf8String({ value: path }),
                                new asn1js.OctetString({
                                    valueHex: nonce,
                                }),
                                new asn1js.OctetString({
                                    valueHex: boxedData,
                                }),
                            ],
                        });
                        return [2 /*return*/, sequence.toBER(false)];
                }
            });
        });
    };
    Box.unbox = function (_a) {
        var passWallet = _a.passWallet, data = _a.data;
        return __awaiter(this, void 0, void 0, function () {
            var boxBuffer, decodedData, sequence, serial, nonce, boxedData, address, unboxedData;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        Box.schema = new asn1js.Sequence({
                            name: 'dataBox',
                            value: [
                                new asn1js.Integer({
                                    name: 'version',
                                }),
                                new asn1js.Utf8String({
                                    name: 'serial',
                                }),
                                new asn1js.OctetString({
                                    name: 'nonce',
                                }),
                                new asn1js.OctetString({
                                    name: 'boxedData',
                                }),
                            ],
                        });
                        boxBuffer = data.buffer.slice(data.byteOffset, data.byteLength + data.byteOffset);
                        decodedData = asn1js.verifySchema(boxBuffer, Box.schema);
                        if (!decodedData.verified) {
                            throw new error_1.EncryptionError("Box could not be verified against schema");
                        }
                        sequence = decodedData.result;
                        serial = sequence.serial.valueBlock.value;
                        nonce = new Uint8Array(sequence.nonce.valueBlock.valueHex);
                        boxedData = new Uint8Array(sequence.boxedData.valueBlock.valueHex);
                        return [4 /*yield*/, passWallet.deriveAddress({
                                path: serial,
                                type: modena_1.AddressType.BOX,
                            })];
                    case 1:
                        address = _b.sent();
                        return [4 /*yield*/, address.secretBoxDecrypt({
                                nonce: nonce,
                                box: boxedData,
                            })];
                    case 2:
                        unboxedData = _b.sent();
                        return [2 /*return*/, unboxedData];
                }
            });
        });
    };
    return Box;
}());
exports.Box = Box;
//# sourceMappingURL=box.js.map